import {
  CHANGE_ROWDEF_LIST_EMPTY,
  CHANGE_SELECTED_ROWDEF,
  RESET_ACCOUNTS_STATE,
} from "features/budget/accounts/rdx/accounts.actions";

const INITIAL_STATE = {
  rowDefinition: null,
  listEmpty: false,
};

// eslint-disable-next-line default-param-last
const accountsRdxReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_SELECTED_ROWDEF:
      return {
        ...state,
        rowDefinition: {
          id: payload.rowDefinitionID,
          name: payload.rowDefinitionName,
        },
      };
    case CHANGE_ROWDEF_LIST_EMPTY:
      return {
        ...state,
        listEmpty: payload.empty,
      };
    case RESET_ACCOUNTS_STATE:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};

export default accountsRdxReducer;
